// @ts-strict-ignore
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-overlay',
  template: '<div class="loader"></div>',
  styleUrls: ['./overlay.component.scss']
})
export class OverlayComponent {

  @Input() opacity: number;
}
